var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"content":"想知道您的潜在客户有哪些？","url":_vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }